import React from "react";
import "./MicroplateReadout2.scss";
import { MicroplateReadoutProps } from "../types";
export const MicroplateReadout2 = (props: MicroplateReadoutProps) => {
  const columns = ["1", "2", "3", "4", "5", "6", "7", ""];
  const rows = ["A", "B", "C", "D", "E", "F", "G"];

  return (
    <div className="microplate-readout-container">
      <div className="grid-container">
        <div className="corner-triangle"></div>
        <div className="grid-header">
          <div className="grid-cell header-cell"></div>
          {columns.map((col) => (
            <div key={col} className="grid-cell header-cell">
              {col}
            </div>
          ))}
        </div>
        <div className="grid-body">
          {rows.map((row) => (
            <div key={row} className="grid-row">
              <div className="grid-cell row-header">{row}</div>
              {columns.map((col) => {
                const cell = props.wellsColors[row]?.[col];
                const value =
                  typeof cell === "object" && cell !== null && "value" in cell
                    ? cell.value.toFixed(3)
                    : parseInt(col) < 4
                      ? "0.000"
                      : "";
                const color =
                  (parseInt(col) < 4 && props.wellsColors[row]?.color) ||
                  "none";
                return (
                  <div
                    key={`${row}-${col}`}
                    className="grid-cell"
                    style={{
                      backgroundColor: color,
                    }}
                  >
                    {value}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
